import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../Context/ConfigContext';
import { useParams } from 'react-router-dom';
import PartsCard from '../../../Components/Cards/PartsCard';
import { ToastContainer, toast } from 'react-toastify';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton, XIcon } from "react-share";
import FooterOffers from "../../Home/FooterOffers";
import OwlCarousel from "react-owl-carousel";
import "react-multi-carousel/lib/styles.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import slugify from 'slugify';
import PartImages from './PartImages';

import OESection from './OESection';
import { AddToRecent } from '../../../Helper/RecentCart';
import RecentViews from '../../Home/RecentViews';
import Reviews from './Reviews';
import RelatedCategories from './RelatedCategories';
import CompatibilityCars from './CompatibilityCars';
import EquivalentParts from './EquivalentParts';
import { AddToCart, GetCartItemQty } from '../../../Helper/MyCart';
import { AddToCartNotifier } from '../../../Components/CartComponents';
import PriceComparison from './PriceComparison';
import { RiFacebookBoxLine, RiLinkedinBoxFill, RiMailFill, RiTwitterXFill, RiWhatsappFill } from 'react-icons/ri';
import { Helmet } from 'react-helmet';
import CarInfoBox from '../../Cars/CarInfoBox';
const PartDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = localStorage.getItem('lang');
  const dir = localStorage.getItem('dir');

  const { gdcURL, apiURL, PCID, setCategories, categories, setCartItemsQty, currency, isUserInternational, setIsCartDropdownOpen } = useContext(ConfigContext);

  const { part_slug } = useParams();
  const ART_ID = part_slug.split('-').slice(-1);
  const SUP_ID = part_slug.split('-')[part_slug.split('-').length - 2];
  const STR_ID = part_slug.split('-')[part_slug.split('-').length - 3];
  const [loading, setLoading] = useState(true);
  const [InvalidCarMatchWithPart, setInvalidCarMatchWithPart] = useState(localStorage.getItem('car_info') ? true : false);
  const [InvalidCarMatchWithPartLoading, setInvalidCarMatchWithPartLoading] = useState(true);
  const [partInfo, setpartInfo] = useState();

  const [crosses, setCrosses] = useState();
  const [loadingCrosses, setLoadingCrosses] = useState(false);
  const car_info = localStorage.getItem('car_info') ? JSON.parse(localStorage.getItem('car_info')) : [];
  const [qtyOptions, setQTYOptions] = useState([]);
  const [selectQty, setSelectedQty] = useState(1);
  const location = useLocation();

  const [price, setPrice] = useState(0);
  const [priceDisplay, setPriceDisplay] = useState('...');
  const [qty, setQTY] = useState(0);
  const incrementQty = async(part) => {
    var prev_qty = await GetCartItemQty(part.ART_ARTICLE_NR.replaceAll('-', '').replaceAll(' ', '').replaceAll('.', ''));
    console.log("part", part)
    if(Number(qty) > Number(selectQty)+prev_qty){
      setSelectedQty(prevQty => prevQty + 1);
    }else{
      toast.success(<AddToCartNotifier item_name={t('sorry_we_have_only', {value: qty})}  />, { })
    }
  };

  const decrementQty = () => {
    setSelectedQty(prevQty => (prevQty > 1 ? prevQty - 1 : 1)); // Assuming quantity can't be less than 1
  };
  useEffect(() => {
    checkCountry();
  }, [isUserInternational])
  const checkCountry = () => {
    if (isUserInternational && partInfo && partInfo) {

      setPTINTL(partInfo.PT_INTL)
    } else {
      setPTINTL(1);
    }
  }
  useEffect(() => {

    GetPartInfo();
    var tqtys = [];
    for (var i = 1; i < 100; i++) {
      tqtys.push({ value: i, label: `${i}` });
    }
    setQTYOptions(tqtys);
    window.scrollTo(0, 0);
  }, [location])
  const [PTINTL, setPTINTL] = useState(0);
  const GetPartInfo = () => {

    setLoading(true);
    fetch(`${gdcURL}/Parts/GetNewPartInfo?art_number=&sup_id=${SUP_ID}&art_id=${ART_ID}&lang=${localStorage.getItem('lang')}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("data.data", data.data)
        setpartInfo(data.data);

        GetPartCrossRef(data.data.ART_ID);
        setQTY(data.data.VD_QTY);
        checkCountry();

        setLoading(false)
        var row = data.data;
        GetPrice(row.ART_ARTICLE_NR.replaceAll('-', '').replaceAll(' ', ''));
        // console.log('AddToRecent',[row.ART_ID,row.ART_ARTICLE_NR, row.PRODUCT_GROUP_NAME, 0, 0,  1, row.MEDIA_SOURCE, window.location.href])

        AddToRecent(row.ART_ID, row.ART_ARTICLE_NR, row.ART_SUP_BRAND + ' ' + row.PRODUCT_GROUP_NAME, 0, 0, 1, row.MEDIA_SOURCE, window.location.href, SUP_ID);
        window.scrollTo(0, 0);
      })
  }



  const GetPartCrossRef = (art_id) => {

    fetch(`${gdcURL}/Parts/GetPartCrossRef?lang=en&art_id=${art_id}&lang=en`)
      .then((res) => res.json())
      .then((data) => {
        setCrosses(data.data);

        setLoadingCrosses(false)
      })
  }

  const handleAddToCart = async (part) => {
    var prev_qty = await GetCartItemQty(part.ART_ARTICLE_NR.replaceAll('-', '').replaceAll(' ', '').replaceAll('.', ''));
    var part_name = `${part.ART_SUP_BRAND} ${part.PRODUCT_GROUP_NAME}`;
    const partImg = part.MEDIA_SOURCE ? `${gdcURL}/images/${part.MEDIA_SOURCE}` : `${apiURL}/public/placeholder_category.jpeg`;
    if(Number(qty) >= Number(selectQty)+prev_qty){
      const url = window.location.href;//`/Spare-Parts/Details/${slugify(`${part.PRODUCT_GROUP}`.toLowerCase())}-${slugify(`${part.ART_ARTICLE_NR}`.toLowerCase())}-${STR_ID}-${slugify(`${part.SUP_ID}`.toLowerCase())}-${slugify(`${part.ART_ID}`.toLowerCase())}`;
    
      await AddToCart(part.ART_ID, part.ART_ARTICLE_NR.replaceAll('-', '').replaceAll(' ', '').replaceAll('.', ''), part_name, part.mrp ?? 0, price, selectQty, partImg, url,  part.VD_QTY);
      setCartItemsQty();

      setIsCartDropdownOpen(true);
      window.scrollTo(0, 0);
      // toast.success(<AddToCartNotifier item_name={part_name} item_img={partImg} />, {
      //   onClose: () => {

      //   }
      // })
    }else{
      toast.success(<AddToCartNotifier item_name={t('sorry_we_have_only', {value: qty})}  item_img={partImg} />, { })
    }

  }
  const GetPrice = (part_number) => {

    fetch(`${gdcURL}/Parts/GetPrice?number=${part_number}&vendor_id=1&lang=${locale ?? 'en'}&currency=${currency}`)
      .then((res) => res.json())
      .then((response) => {

        setPrice(response.data.pricing.price);
        setPriceDisplay(response.data.pricing.price_display);

      })
  }
  const invalidPartMatch = (value) => {

    setInvalidCarMatchWithPart(value);
    setInvalidCarMatchWithPartLoading(false);
  }
  useEffect(() => {
   
  }, [InvalidCarMatchWithPart])

  useEffect(() => {
    // Set a default/fallback title
    document.title = "Parts Details | Ghayar";
    
    // Update title when part info is loaded
    if (!loading && partInfo && partInfo) {
      const part = partInfo;
      document.title = `${part.ART_SUP_BRAND} ${part.ART_ARTICLE_NR} ${part.PRODUCT_GROUP_NAME} | Ghayar`;
    }
  }, [loading, partInfo]);

  return (
    <main className="main" dir={dir} style={{textAlign: dir==='rtl'?'right': ''}}>
      <Helmet>
        <title>
          {loading 
            ? "Parts Details | Ghayar" 
            : partInfo && partInfo 
              ? `${partInfo.ART_SUP_BRAND} ${partInfo.ART_ARTICLE_NR} ${partInfo.PRODUCT_GROUP_NAME} | Ghayar` 
              : "Parts Details | Ghayar"
          }
        </title>
        <meta name="keywords" content={partInfo && partInfo ? `${partInfo.ART_SUP_BRAND}, ${partInfo.ART_ARTICLE_NR}, ${partInfo.PRODUCT_GROUP_NAME}, Ghayar` : "spare parts, auto parts, Ghayar"} />
      </Helmet>
      
      {
        <div className="container">

          <nav aria-label="breadcrumb" className="breadcrumb-nav">
            <ol className="breadcrumb" dir={dir}>
              <li className="breadcrumb-item">
                <NavLink to={'/'}>
                  <i className="icon-home" />
                </NavLink>
              </li>
              <li className="breadcrumb-item">
                <NavLink to={`/Spare-Parts/Catelog`}>{t("catelog")}</NavLink>
              </li>
              {partInfo ? (
                <li className="breadcrumb-item">
                  <NavLink to={`/Spare-Parts/${slugify(`${partInfo.PRODUCT_GROUP_NAME}`.toLowerCase())}-${STR_ID}`}>
                    {partInfo.PRODUCT_GROUP_NAME}{" "}
                  </NavLink>
                </li>
              ) : (
                <li className="breadcrumb-item">
                  <NavLink to={() => { }}>...</NavLink>
                </li>
              )}
            </ol>


          </nav>
          <CarInfoBox />
          {/* {partInfo && InvalidCarMatchWithPartLoading === false && localStorage.getItem('car_info') && car_info && car_info[0] && 
            <div>
              {loading === false && InvalidCarMatchWithPart ?
                <div className='pl-5 pr-5 pt-5 pb-3' style={{ backgroundColor: 'rgb(254, 245, 245)' }}>
                  <div style={{ color: 'rgb(226, 10, 24)' }}><i className="fas fa-times-circle"></i> {t('this_part_fits_your')}</div>
                  <div style={{ color: 'rgb(254, 245, 245)' }}><h3 style={{ fontWeight: 400 }}> {car_info && car_info[0] && car_info[0].TYPEL}</h3></div>
                </div>
                :
                <div className='pl-5 pr-5 pt-5 pb-3' style={{ backgroundColor: 'rgb(245, 254, 247)' }}>
                  <div style={{ color: '#009e7e' }}><i className="fas fa-check-circle"></i> {t('this_part_fits_your')}</div>
                  <div style={{ color: '#009e7e' }}><h3 style={{ fontWeight: 400 }}> {car_info && car_info[0] && car_info[0].TYPEL}</h3></div>
                </div>

              }
            </div>
          } */}

          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <div className="product-single-container product-single-default">
            <div className="cart-message d-none">
              <strong className="single-cart-notice">

              </strong>
              <span>has been added to your cart.</span>
            </div>
            <div>
              <div className='col-md-12'>
                <h3 className="product-title mb-2 mt-2" style={{direction: dir === 'rtl'? 'ltr': ''}} >
                  {partInfo && partInfo.ART_SUP_BRAND} {partInfo && partInfo.ART_ARTICLE_NR} {partInfo && partInfo.PRODUCT_GROUP_NAME}
                </h3>
              </div>
              <div className='col-md-12'>
                  {partInfo && partInfo.ARTICLE_CRITERIA && Array.isArray(partInfo.ARTICLE_CRITERIA) && (
                    <div className="product-specs">
                      {partInfo.ARTICLE_CRITERIA.map((criteria, index) => (
                        <span key={`top-spec-${criteria.criteria_id || index}`} className="spec-item">
                          {dir === 'rtl' ? (
                            <>{criteria.criteria_ar}: {criteria.value_ar}</>
                          ) : (
                            <>{criteria.criteria_en}: {criteria.value_en}</>
                          )}
                          {index < partInfo.ARTICLE_CRITERIA.length - 1 && ' | '}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              <div className='col-md-12 mt-1'>
                <div className="ratings-container">
                  {partInfo && <span className="mt-1 ml2 mr-2">{t('article_number', { value: partInfo.ART_ARTICLE_NR })} | </span>}

                 
                  {/* End .product-ratings */}
                  <NavLink to={() => { }} className="rating-link" onClick={(e) => {
                    e.preventDefault();
                    const reviewsSection = document.getElementById('reviews-section');
                    if (reviewsSection) {
                      reviewsSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}>
                  {partInfo && partInfo.REVIEWS && partInfo.REVIEWS !== "0" ? 
                        '★'.repeat(Math.round(partInfo.REVIEWS.split('-')[0])) + '☆'.repeat(5 - Math.round(partInfo.REVIEWS.split('-')[0])) 
                        : '☆☆☆☆☆'
                      }
                    ( {partInfo && partInfo.REVIEWS && partInfo.REVIEWS !== "0"?partInfo.REVIEWS.split('-')[1]: 0} {t('reviews')} )
                  </NavLink>
                  {/* End .product-ratings */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-5 col-md-6 product-single-gallery">
                {partInfo && <PartImages ART_ID={partInfo.ART_ID} />}
              </div>

              {/* End .product-single-gallery */}
              <div className="col-lg-3 col-md-6 product-single-details">
                {/* End .price-box */}
                <div className="product-desc ml-0">
                  <div
                    className="tab-pane fade show active"
                    id="product-desc-content"
                    role="tabpanel"
                    aria-labelledby="product-tab-desc"
                  >
                    <div className="product-desc-content">
                      {
                        partInfo &&  <div >
                            <h5 style={{ fontSize: '18px' }}>{t('specification')}</h5>
                            <table className="table" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'left', fontSize: '12px', color: '#333' }}>
                              <tbody>
                                {partInfo && partInfo.ARTICLE_CRITERIA && Array.isArray(partInfo.ARTICLE_CRITERIA) && 
                                  partInfo.ARTICLE_CRITERIA.map((criteria, index) => (
                                    <tr key={`info-tr-${index}`}>
                                      <td>
                                        <span style={{ fontWeight: '500' }}>
                                          {dir === 'rtl' ? criteria.criteria_ar : criteria.criteria_en}
                                        </span>
                                      </td>
                                      <td>
                                        <span>
                                          {dir === 'rtl' ? criteria.value_ar : criteria.value_en}
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                        
                      }
                    </div>
                    {/* End .product-desc-content */}
                  </div>
                </div>
                {/* End .product-desc */}
                <ul className="single-info-list ml-2" >
                  <li className="mr-5">
                    {t('part_number')} :
                    <strong>
                      {partInfo && partInfo.ART_ARTICLE_NR}
                    </strong>
                  </li>
                  <li>
                    {t('category')}:{" "}
                    <strong>
                      <NavLink to={() => { }} className="product-category">
                        {partInfo && partInfo.PRODUCT_GROUP_NAME}
                      </NavLink>
                    </strong>
                  </li>
                  {car_info && car_info[0] && car_info[0].ART_SUP_BRAND &&
                    <li>

                      {t('brand')}:{" "}
                      <strong>
                        <NavLink to={() => { }} className="product-category">
                          {car_info && car_info[0] && car_info[0].ART_SUP_BRAND && car_info[0].ART_SUP_BRAND}
                        </NavLink>
                      </strong>
                      ,
                    </li>}
                  <li> {t('condition')}:{" "} <strong> <NavLink to={() => { }} className="product-category"> {t('new')} </NavLink> </strong> </li>

                </ul>

                {/* End .product-action */}
                <hr className="divider mb-0 mt-0" />
                <div className="product-single-share mb-3">
                  <label className="sr-only">{t('share')}:</label>
                  <div className="social-icons mr-2">
                    <FacebookShareButton url={window.location.href}>
                      <i className="social-icon  fab" target="_blank" title="Facebook" >
                        <RiFacebookBoxLine />
                      </i>
                    </FacebookShareButton>
                    <TwitterShareButton url={window.location.href}>
                      <i className="social-icon  fab" target="_blank" title="Twitter" >
                        <RiTwitterXFill />
                      </i>
                    </TwitterShareButton>
                    <LinkedinShareButton url={window.location.href}>
                      <i className="social-icon  fab" target="_blank" title="Linkedin" >
                        <RiLinkedinBoxFill />
                      </i>
                    </LinkedinShareButton>
                    <WhatsappShareButton url={window.location.href}>
                      <i className="social-icon  fab" target="_blank" title="WhatsApp" >
                        <RiWhatsappFill />
                      </i>
                    </WhatsappShareButton>
                    <EmailShareButton url={window.location.href}>
                      <i className="social-icon  fab" target="_blank" title="Mail" >
                        <RiMailFill />
                      </i>
                    </EmailShareButton>

                  </div>
                  {/* End .social-icons */}

                </div>
                {/* End .product single-share */}
              </div>
              <div className='col-lg-4 col-md-6'>
                <div className="product-action">
                  <div className='row'>
                    <div className='col-md-12 mb-2'>
                      {price > 0 && partInfo && partInfo && PTINTL > 0 && <span ><i style={{ color: 'rgb(11, 207, 28)' }} className="far fa-dot-circle"></i> {t('in_stock')}</span>}
                      {price <= 0 && <h1 className='mt-4' >{t('out_of_stock')}</h1>}
                      {price > 0 && partInfo && partInfo && PTINTL > 0 && <h1 className='mt-4' style={{ lineHeight: 0.5 }}> {priceDisplay}</h1>}
                      {price > 0 && partInfo && partInfo && PTINTL > 0 && <small className='mt-2'>{t('price_included_vat_excluded_delivery')}</small>}
                      {partInfo && partInfo && PTINTL === 0 &&
                        <div className='pl-5 pr-5 pt-3 pb-1' style={{ backgroundColor: 'rgb(254, 245, 245)' }}>
                          <div style={{ color: 'rgb(226, 10, 24)' }}><i className="fas fa-globe"></i> {t('international_delivery_not_for', { value: '' })} </div>
                          <div style={{ color: 'rgb(254, 245, 245)' }}><h3 style={{ fontWeight: 400 }}> {partInfo && partInfo.PRODUCT_GROUP_NAME}</h3></div>
                        </div>
                      }
                      {/* {partInfo && partInfo && PTINTL === 0 && <span className='alert alert-danger mt-2' >
                      {t('international_delivery_not_for', {value: partInfo && partInfo.PRODUCT_GROUP_NAME})}
                      
                    </span>} */}
                    </div>
                    {price > 0 && partInfo && partInfo && PTINTL > 0 &&
                      <div className="col-md-5" style={{ width: '100%' }}>
                        <div className="input-group mb-3">
                          <div className="input-group-prepend" onClick={decrementQty}>
                            <span className="input-group-text"><i className="fas fa-minus"></i></span>
                          </div>
                          <div type="number" className="form-control no-arrows" value="1" style={{ textAlign: 'center', lineHeight: '35px' }} aria-label="Amount (to the nearest dollar)" >{selectQty}</div>
                          <div className="input-group-append" onClick={() => incrementQty(partInfo)}>
                            <span className="input-group-text"><i className="fas fa-plus"></i></span>
                          </div>
                        </div>
                      </div>
                    }
                    <div className="col-md-7 mb-2">
                      {price > 0 && partInfo && partInfo && PTINTL > 0 &&
                        <button onClick={() => handleAddToCart(partInfo)} className="btn btn-dark add-cart mr-2 text-light " title={t('add_to_cart')} >
                          {t('add_to_cart')}
                        </button>
                      }
                    </div>
                  </div>

                </div>
              </div>
              {/* End .product-single-details */}
            </div>
            {/* End .row */}
          </div>
          {partInfo && <CompatibilityCars ART_ID={partInfo.ART_ID} invalidPartMatch={invalidPartMatch} />}

          {partInfo && <OESection ART_ID={partInfo.ART_ID} STR_ID={STR_ID} />}
          <hr style={{ marginTop: 0, marginBottom: '10px' }} />
          {/* {partInfo && <EquivalentParts STR_ID={STR_ID} />} */}
          {partInfo && STR_ID !== null && <RelatedCategories STR_ID={STR_ID} />}

          {/* {partInfo && <PriceComparison STR_ID={STR_ID} PART_TITLE={`${partInfo.ART_SUP_BRAND} ${partInfo.ART_ARTICLE_NR}`} />} */}


          {/* End .products-section */}
          <RecentViews />
          <div id="reviews-section">
          {partInfo && <Reviews title={t('have_you_ever_bought', { value: `${partInfo.ART_SUP_BRAND} ${partInfo.ART_ARTICLE_NR} ${partInfo.PRODUCT_GROUP_NAME} ` })} partNumber={partInfo.ART_SEARCH_NUMBER} reviews={partInfo && partInfo.REVIEWS} />}
          </div>
          <br /> <br />
          {/* <FooterOffers /> */}
          {/* End .row */}
        </div>
      }

      {/* End .container */}
    </main>
  );
}

export default PartDetails;